import { Translation } from "@ha/data/basic";

import { Placeholder, QuestionAnswerEnum } from "./fixed-template.model";
import { SafetyRule } from "./safety-rule";

export interface QuestionDto {
    customerQuestion: CustomerQuestion;
    fixedQuestion: FixedQuestion;
}

export interface FixedQuestion extends BaseQuestion {
    alert: FixedQuestionAlert;
    customerComment: FixedQuestionComment;
}

export interface CustomerQuestion extends BaseQuestion {
    alternatives: CustomerQuestionAnswer;
}

export interface BaseQuestion {
    id: number;
    currentAnswer: CustomerQuestionAnswer;
    currentTextAnswer: string | null;
    currentNumberAnswer: number | null;
    currentConditionText: string | null;
    currentDateTimeAnswer: Date | null;
    currentFlammableMaterialMeasurements: FlammableMaterialMeasurement[] | null;
    currentSafetyEquipmentAnswers: SafetyEquipmentAnswerSelection[] | null;
    isPreparatory: boolean;
    translations: Translation[];
    comment: Translation[];
    allowComments: boolean;
    allowPhotos: boolean;
    safetyRules: SafetyRule[];
    answerType: QuestionAnswerType;
    answerTypeConfiguration?: AnswerTypeConfiguration;
    safetyEquipmentOptions?: SafetyEquipmentOption[];
}

export interface FlammableMaterialMeasurement {
    flammableMaterialId: number;
    value: number;
}

export interface SafetyEquipmentAnswerSelection {
    questionId: number;
    safetyEquipmentId?: number | null;
    customText?: string | null;
}

export interface SafetyEquipmentOption {
    id: number;
    priority: number;
    translations: Translation[];
}

export interface QuestionOption {
    id: number;
    translations: Translation[];
    triggersAtex?: boolean;
}

export enum QuestionAnswerType {
    YesNo = 1,
    YesNoNotApplicable = 2,
    YesNoWithCondition = 3,
    Text = 4,
    Number = 5,
    YesNoNotApplicableWithCondition = 6,
    DateTime = 7,
    SubstanceSelection = 8,
    SubstanceMeasurement = 9,
    SafetyEquipmentSelection = 10,
    OptionSelection = 11,
}

export interface AnswerTypeConfiguration {
    conditionLabel?: Translation[];
    required?: boolean;
    conditionRequired?: boolean;
    showConditionOnYes?: boolean;
    maxLength?: number;
    minLength?: number;
    minValue?: number;
    maxValue?: number;
    placeholder?: Translation[];
    inputPattern?: string;
    allowMultiple?: boolean;
    freeTextOptionId?: number | null;
    freeTextRequired?: boolean;
    options?: QuestionOption[];
}

export interface FixedQuestionAlert {
    answerIsNo: boolean;
    answerIsYes: boolean;
    confirmToProceed: boolean;
    proceedNotAllowed: boolean;
    translations: Translation[];
    placeholder: Placeholder | null;
}

export interface FixedQuestionComment {
    customerPermitTemplateId: number;
    fixedQuestionId: number;
    translations: Translation[];
    allowComments: boolean;
    allowPhotos: boolean;
}

export enum CustomerQuestionAnswer {
    Yes = 1,
    No = 1 << 1,
    NotApplicable = 1 << 2,
    Condition = 1 << 3,
    Now = 1 << 4,
    SpecificTime = 1 << 5,
}

export interface QuestionAnswer {
    questionId: number;
    answer?: QuestionAnswerEnum;
    selectedOptionIds?: number[];
    textAnswer?: string;
    numberAnswer?: number;
    dateTimeAnswer?: Date;
    conditionText?: string;
    selectedFlammableMaterialIds?: number[];
    currentFlammableMaterialMeasurements?: FlammableMaterialMeasurement[];
    safetyEquipmentAnswers?: SafetyEquipmentAnswerSelection[];
}
